import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsOlx() {
  return <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.OLX} />;
}
